<div id="container">
  <div *ngIf="!navigationInProgress && !loading" id="content-hugger">
    <div class="logo-wrapper" (click)="report()">
      <img
        *ngIf="displayMerchantLogo && partnerLogoUri"
        [src]="partnerLogoUri"
        (error)="hideMerchantLogo()"
        alt="Merchant logo"
      />
      <app-zaver-icon *ngIf="!displayMerchantLogo" [size]="28" name="zaverLogo"></app-zaver-icon>
    </div>
    <button
      *ngIf="cancelUrl && checkoutStatus !== 'COMPLETED' && !hideCancelButton"
      [attr.disabled]="navigationInProgress ? '' : null"
      class="close-icon"
      (click)="setModalActive(true)"
    >
      <app-zaver-icon [size]="14" name="close"></app-zaver-icon>
    </button>
  </div>
</div>

<zaver-details-modal
  *ngIf="modalActive"
  (onClose)="setModalActive(false)"
  [color]="'#E6E9EF'"
  [title]="modalTitle"
  [titleColor]="'#1B2235'"
>
  <div class="small-modal-wrapper">
    <div class="modal-text">
      {{ modalText }}
    </div>
    <div class="modal-button-container">
      <button class="modal-button" (click)="setModalActive(false)">
        {{ secondaryButtonText }}
      </button>

      <button
        class="modal-button"
        [disabled]="navigationInProgress"
        (click)="routeToCancelUrl()"
      >
        {{ primaryButtonText }}
      </button>
    </div>
  </div>
</zaver-details-modal>
